import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyAKNY9nOwSZ8dpH7a5wHl9hNuBD1JlTGJk",
    authDomain: "florakart-b24d5.firebaseapp.com",
    projectId: "florakart-b24d5",
    storageBucket: "florakart-b24d5.appspot.com",
    messagingSenderId: "685170564242",
    appId: "1:685170564242:web:003fd83e3f6f35b1249a4b"
  };
  

const firebaseApp = firebase.initializeApp(firebaseConfig);
const provider = new firebase.auth.GoogleAuthProvider();
const db = firebaseApp.firestore();
const auth = firebase.auth();
export { auth, provider };
export default db;
